/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
import React, { Component } from 'react';
import {
    Button,
    ButtonToolbar,
    Label,
    FormGroup,
    Modal,
    ModalBody,
} from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
// import BasicNotification from './Notifications/BasicNotification';

class SendNewPassModal extends Component {
    static defaultProps = {
        title: '',
        message: '',
        colored: false,
        header: false,
        selectedOption: null,
    };

    state = {
        isCompany: false,
        clientExist: false
    }

    searchClientRender = () => {

        const {
            value,
            toggle,
            onSubmitSend,
        } = this.props;

        return (
            <form className="form form--horizontal">
                <ModalBody>
                    <FormGroup style={{ textAlign: 'left' }}>
                        <Label className="label_autofin" for="rut">La nueva contraseña se enviará al siguiente correo: <span>{' ' + value.email}</span></Label>
                    </FormGroup>
                </ModalBody>
                <ButtonToolbar className="modal__footer" style={{ justifyContent: 'center' }}>
                    <Button className="asignar" onClick={toggle}>Cancelar</Button>{' '}
                    <Button
                        className="asignar just_this"
                        onClick={onSubmitSend}
                        id="added"
                    >Enviar Contraseña</Button>
                </ButtonToolbar>
            </form>
        );
    }

    render() {
        const {
            isOpen,
            toggle,
            value
        } = this.props;

        return (
            <div>
                <Modal
                    isOpen={isOpen}
                    toggle={toggle}
                    className="modal-add-client modal-dialog--success"
                >
                    <h4 className="label_autofin" style={{ textAlign: 'left' }}> <strong>¿Desea enviar nueva contraseña a {value.name}?</strong></h4>
                    <div className="modal__header">
                        <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
                    </div>
                    {this.searchClientRender()}

                </Modal>
            </div>
        );
    }
}

export default SendNewPassModal;
